
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import WebhookMixin from '~/mixins/webhookMixin'

export default defineComponent({
  name: 'DeleteWebhookEndpoint',
  mixins: [WebhookMixin, ActiveUserMixin],
  props: {
    webhookId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      deletingEndpoint: false,
      showConfirmDelete: false
    }
  },
  methods: {
    async deleteTemplate(close: () => void): Promise<void> {
      this.deletingEndpoint = true
      try {
        const response = await this.deleteEndpoint({ webhookId: this.webhookId })
        if (response.ok) {
          await this.refetchEndpointList()
          this.$router.push(this.$generateRoute(['settings', 'webhooks'], false, true))
          this.$toast.success('Successfully deleted the webhook.')
          close()
        } else {
          throw new Error(
            'Unable to delete webhook endpoint. If this issue persists, contact support'
          )
        }
      } catch (e) {
        this.logErrorForUser(e as Error, 'Delete webhook', { webhookId: this.webhookId })
        this.$toast.danger((e as Error).message.replace('GraphQL error: ', ''))
      } finally {
        this.deletingEndpoint = false
      }
    },
    close(): void {
      this.showConfirmDelete = false
    }
  }
})
